import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CheckboxTable} from '../../../tools/checkbox-table/checkbox-table';

@Component({
  selector: 'app-checkbox-all-table',
  imports: [
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './checkbox-all-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkbox-all-table.component.scss'
})
export class CheckboxAllTableComponent {
  @Input() checked: boolean = false;

  private checkboxTable: CheckboxTable | null = null;

  setCheckboxTable(checkboxTable: CheckboxTable | null): void {
    this.checkboxTable = checkboxTable;
    this.checkboxTable?.registerCheckboxAllTableComponents(this);
  }

  onChanged(): void {
    if (this.checkboxTable) {
      if (this.checked) {
        this.checkboxTable.checkAll();
      } else {
        this.checkboxTable.uncheckAll();
      }
    }
  }
}
